export const isOneStudy = process.env.REACT_APP_PROJECT === 'onestudy';
export const isNaniStudy = process.env.REACT_APP_PROJECT === 'nanistudy';
export const isYunlinStudy = process.env.REACT_APP_PROJECT === 'yunlinstudy';
export const isChiayiStudy = process.env.REACT_APP_PROJECT === 'chiayistudy';
